var map = {
	"./About Us-Strategic Approach.jpg": 29011,
	"./Chemical.jpg": 42419,
	"./Chemical_landpage.jpg": 80242,
	"./DSC0441.jpg": 24832,
	"./Gas.jpg": 88384,
	"./Gas_landpage.jpg": 73151,
	"./Hsse_landscape.jpg": 52186,
	"./Hsse_page.jpg": 16428,
	"./Oil.jpg": 22155,
	"./Oil_landpage.jpg": 60042,
	"./Oiltanking_South-America_Argentina_Brandsen_Tanks_2010-01-15_02.jpg": 5166,
	"./Oiltanking_South-America_Brazil_Vitoria_Tanks_2015-02-04_5.jpg": 31775,
	"./Oiltanking_South-America_Brazil_Vitoria_Truckloading_2012-06-29_0942.jpg": 17379,
	"./Others.jpg": 59486,
	"./Others_landpage.jpg": 91157,
	"./Responsability-HSSE-Security.jpg": 96688,
	"./Responsability-Our Employees.jpg": 73127,
	"./Responsability.jpg": 74425,
	"./Sostenibilidad.png": 94543,
	"./Sustainability.png": 2556,
	"./Sustainable-Growth-Landscape.jpg": 29474,
	"./Sustainable-Growth.jpg": 31950,
	"./Sustentabilidade.png": 26896,
	"./about/about_us_0.jpg": 45166,
	"./about/about_us_1.jpg": 41003,
	"./aboutUs.jpg": 73164,
	"./callao.jpg": 5639,
	"./carousel/AboutUs01.jpg": 92534,
	"./carousel/DSC0405 03.jpg": 70696,
	"./carousel/DSC0441.jpg": 95423,
	"./carousel/Hsse_landscape.jpg": 57095,
	"./certificates/otamerica_ar_spanish_2024_certification_badge.png": 8284,
	"./certificates/otamerica_br_portuguese_2024_certification_badge.png": 21386,
	"./certificates/otamerica_co_spanish_2024_certification_badge.png": 22145,
	"./certificates/otamerica_mx_spanish_2024_certification_badge.png": 13070,
	"./certificates/otamerica_pa_spanish_2024_certification_badge.png": 17752,
	"./certificates/otamerica_pe_spanish_2024_certification_badge.png": 54564,
	"./ethicsAndCompliance.jpg": 45437,
	"./healthAndSafety.jpg": 91004,
	"./hssePolicy.jpg": 39662,
	"./image_ot-brazil-vitoria_tanks6_1920px.jpg": 11517,
	"./image_ot-flags_1920px.jpg": 56875,
	"./image_ot-germany-hamburg_operators_1920px.jpg": 61290,
	"./image_tank-storage-construction2_1920px.jpg": 95558,
	"./jdpProgram/jdpProgram.jpg": 88136,
	"./jdpProgram/jdpProgram1.jpg": 70831,
	"./news/OiltankingLogisticaBrasil.jpg": 8327,
	"./news/OiltankingLogisticaBrasil_1.jpg": 39699,
	"./news/Oiltanking_South-America_Argentina_Puerto-Rosales_Tanks_2009-03-04_1070341.jpg": 69976,
	"./news/dji_0596_v3.jpg": 73507,
	"./news/dji_20250722152827_0001_v2.jpg": 14755,
	"./news/dji_20250904140448_0006_v1.jpg": 54009,
	"./news/gptw-latam-v2.jpg": 77502,
	"./news/image006.png": 72080,
	"./news/otamerica_esg_report_2024.jpg": 58946,
	"./news/suezmax.jpg": 77574,
	"./offices/AMERICAS_Mexico_Tuxpan_Aerial_Tanks_2021-06_1920x550.jpg": 41032,
	"./offices/Oficina Argentina_BsAs.jpeg": 98092,
	"./offices/Oficina Brasil_RJ.jpeg": 281,
	"./offices/Oficina Mexico.jpeg": 12446,
	"./offices/Oficina Peru.jpeg": 97171,
	"./offices/Oiltanking_South-America_Argentina_Brandsen_Building-Outside_2010-01-15_014.jpg": 26308,
	"./offices/Oiltanking_South-America_Argentina_Puerto-Rosales_Building-Outside_2012-01-24_6584.jpg": 46346,
	"./offices/Oiltanking_South-America_Brazil_Vitoria_Truckloading_2012-06-29_0942.jpg": 8333,
	"./offices/Oiltanking_South-America_Colombia_Cartagena_Terminal-Aerial_2001-06-10.80016292.jpg": 15039,
	"./offices/Oiltanking_South-America_Peru_Callao.jpg": 69896,
	"./offices/Oiltanking_South-America_Peru_Chimbote_Tank_2016-10-13_1.jpg": 2149,
	"./offices/Oiltanking_South-America_Port-Acu.jpg": 66342,
	"./offices/Terminal Page Puerto Bahia.jpg": 62874,
	"./offices/image_ot-panama-coassa-colon_tanks1_1920px.jpg": 86266,
	"./offices/image_ot-peru-andina-services_marine-platform1_1920px.jpg": 37259,
	"./offices/image_ot-peru-eten_tanks_1920px.jpg": 275,
	"./offices/image_ot-peru-matarani_tanks1_1920px.jpg": 37019,
	"./offices/image_ot-peru-salaverry_tanks2_1920px.jpg": 86932,
	"./offices/image_ot-peru-supe_tanks_1920px.jpg": 66458,
	"./pordosol.png": 87849,
	"./pordosol_landpage.png": 60876,
	"./sustainabilityStrategy.jpg": 1583,
	"./terminals/AMERICAS_Mexico_Tuxpan_Aerial_Tanks_2021-06_1920x550.jpg": 27032,
	"./terminals/Oiltanking_Belgium_Antwerp_Gas_Terminal_NV_Image_tanks1_1920px.jpg": 97587,
	"./terminals/Oiltanking_South-America_Argentina_Puerto-Rosales_Tanks_2009-03-04_1070341.jpg": 50466,
	"./terminals/Oiltanking_South-America_Brazil_Vitoria_Tanks-Landscape_2012-06-28_10.jpg": 69354,
	"./terminals/Oiltanking_South-America_Brazil_Vitoria_Truckloading_2012-06-29_0942.jpg": 11869,
	"./terminals/Oiltanking_South-America_Colombia_Cartagena_Terminal-Aerial_2011-06-10.jpg": 6470,
	"./terminals/Oiltanking_South-America_Peru_Callao.jpg": 10968,
	"./terminals/Oiltanking_South-America_Peru_Callao_old.jpg": 76270,
	"./terminals/Oiltanking_South-America_Peru_Chimbote_Tank_2016-10-13_1.jpg": 98645,
	"./terminals/Oiltanking_South-America_Port-Acu.jpg": 44214,
	"./terminals/Terminal Page Puerto Bahia.jpg": 69194,
	"./terminals/image_ot-panama-coassa-colon_tanks1_1920px.jpg": 874,
	"./terminals/image_ot-peru-andina-services_marine-platform1_1920px.jpg": 49851,
	"./terminals/image_ot-peru-eten_tanks_1920px.jpg": 32515,
	"./terminals/image_ot-peru-matarani_tanks1_1920px.jpg": 52971,
	"./terminals/image_ot-peru-salaverry_tanks2_1920px.jpg": 39716,
	"./terminals/image_ot-peru-supe_tanks_1920px.jpg": 96778,
	"./terminals/otSouthAmericaArgentinaBrandsenTerminal.jpg": 21733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;